import React, { useState } from "react";
import { ChevronDown, Camera, Upload } from "lucide-react";
import toast from "react-hot-toast";
import { rideAPI, uploadAPI } from "../services/api";
import PhotoCaptureButton from "./PhotoCaptureButton";
import SubmitCountdown from "./SubmitCountdown";

const COUNTRY_CODES = [
  { code: "+93", label: "+93 (Afghanistan)" },
  { code: "+358", label: "+358 (Aland Islands)" },
  { code: "+355", label: "+355 (Albania)" },
  { code: "+213", label: "+213 (Algeria)" },
  { code: "+1-684", label: "+1-684 (American Samoa)" },
  { code: "+376", label: "+376 (Andorra)" },
  { code: "+244", label: "+244 (Angola)" },
  { code: "+1-268", label: "+1-268 (Antigua & Barbuda)" },
  { code: "+54", label: "+54 (Argentina)" },
  { code: "+374", label: "+374 (Armenia)" },
  { code: "+297", label: "+297 (Aruba)" },
  { code: "+61", label: "+61 (Australia)" },
  { code: "+43", label: "+43 (Austria)" },
  { code: "+994", label: "+994 (Azerbaijan)" },
  { code: "+973", label: "+973 (Bahrain)" },
  { code: "+880", label: "+880 (Bangladesh)" },
  { code: "+1-246", label: "+1-246 (Barbados)" },
  { code: "+375", label: "+375 (Belarus)" },
  { code: "+32", label: "+32 (Belgium)" },
  { code: "+501", label: "+501 (Belize)" },
  { code: "+229", label: "+229 (Benin)" },
  { code: "+1-441", label: "+1-441 (Bermuda)" },
  { code: "+975", label: "+975 (Bhutan)" },
  { code: "+591", label: "+591 (Bolivia)" },
  { code: "+387", label: "+387 (Bosnia and Herzegovina)" },
  { code: "+267", label: "+267 (Botswana)" },
  { code: "+55", label: "+55 (Brazil)" },
  { code: "+1-284", label: "+1-284 (British Virgin Islands)" },
  { code: "+673", label: "+673 (Brunei)" },
  { code: "+359", label: "+359 (Bulgaria)" },
  { code: "+226", label: "+226 (Burkina Faso)" },
  { code: "+257", label: "+257 (Burundi)" },
  { code: "+855", label: "+855 (Cambodia)" },
  { code: "+237", label: "+237 (Cameroon)" },
  { code: "+1", label: "+1 (Canada)" },
  { code: "+238", label: "+238 (Cape Verde)" },
  { code: "+1-345", label: "+1-345 (Cayman Islands)" },
  { code: "+236", label: "+236 (Central African Republic)" },
  { code: "+235", label: "+235 (Chad)" },
  { code: "+56", label: "+56 (Chile)" },
  { code: "+86", label: "+86 (China)" },
  { code: "+57", label: "+57 (Colombia)" },
  { code: "+269", label: "+269 (Comoros)" },
  { code: "+506", label: "+506 (Costa Rica)" },
  { code: "+385", label: "+385 (Croatia)" },
  { code: "+53", label: "+53 (Cuba)" },
  { code: "+599", label: "+599 (Curacao)" },
  { code: "+357", label: "+357 (Cyprus)" },
  { code: "+420", label: "+420 (Czech Republic)" },
  { code: "+243", label: "+243 (Democratic Republic of the Congo)" },
  { code: "+45", label: "+45 (Denmark)" },
  { code: "+253", label: "+253 (Djibouti)" },
  { code: "+1-767", label: "+1-767 (Dominica)" },
  { code: "+1-809", label: "+1-809 (Dominican Republic)" },
  { code: "+670", label: "+670 (East Timor)" },
  { code: "+593", label: "+593 (Ecuador)" },
  { code: "+20", label: "+20 (Egypt)" },
  { code: "+503", label: "+503 (El Salvador)" },
  { code: "+240", label: "+240 (Equatorial Guinea)" },
  { code: "+291", label: "+291 (Eritrea)" },
  { code: "+372", label: "+372 (Estonia)" },
  { code: "+268", label: "+268 (Eswatini)" },
  { code: "+251", label: "+251 (Ethiopia)" },
  { code: "+691", label: "+691 (Federated States of Micronesia)" },
  { code: "+679", label: "+679 (Fiji)" },
  { code: "+358", label: "+358 (Finland)" },
  { code: "+33", label: "+33 (France)" },
  { code: "+689", label: "+689 (French Polynesia)" },
  { code: "+241", label: "+241 (Gabon)" },
  { code: "+995", label: "+995 (Georgia)" },
  { code: "+49", label: "+49 (Germany)" },
  { code: "+233", label: "+233 (Ghana)" },
  { code: "+350", label: "+350 (Gibraltar)" },
  { code: "+30", label: "+30 (Greece)" },
  { code: "+1-473", label: "+1-473 (Grenada)" },
  { code: "+502", label: "+502 (Guatemala)" },
  { code: "+44-1481", label: "+44-1481 (Guernsey)" },
  { code: "+224", label: "+224 (Guinea)" },
  { code: "+245", label: "+245 (Guinea-Bissau)" },
  { code: "+592", label: "+592 (Guyana)" },
  { code: "+509", label: "+509 (Haiti)" },
  { code: "+504", label: "+504 (Honduras)" },
  { code: "+852", label: "+852 (Hong Kong)" },
  { code: "+36", label: "+36 (Hungary)" },
  { code: "+354", label: "+354 (Iceland)" },
  { code: "+91", label: "+91 (India)" },
  { code: "+62", label: "+62 (Indonesia)" },
  { code: "+98", label: "+98 (Iran)" },
  { code: "+964", label: "+964 (Iraq)" },
  { code: "+353", label: "+353 (Ireland)" },
  { code: "+44-1624", label: "+44-1624 (Isle of Man)" },
  { code: "+972", label: "+972 (Israel)" },
  { code: "+39", label: "+39 (Italy)" },
  { code: "+225", label: "+225 (Ivory Coast)" },
  { code: "+1-876", label: "+1-876 (Jamaica)" },
  { code: "+81", label: "+81 (Japan)" },
  { code: "+962", label: "+962 (Jordan)" },
  { code: "+7", label: "+7 (Kazakhstan)" },
  { code: "+254", label: "+254 (Kenya)" },
  { code: "+686", label: "+686 (Kiribati)" },
  { code: "+965", label: "+965 (Kuwait)" },
  { code: "+996", label: "+996 (Kyrgyzstan)" },
  { code: "+856", label: "+856 (Laos)" },
  { code: "+371", label: "+371 (Latvia)" },
  { code: "+961", label: "+961 (Lebanon)" },
  { code: "+266", label: "+266 (Lesotho)" },
  { code: "+231", label: "+231 (Liberia)" },
  { code: "+218", label: "+218 (Libya)" },
  { code: "+423", label: "+423 (Liechtenstein)" },
  { code: "+370", label: "+370 (Lithuania)" },
  { code: "+352", label: "+352 (Luxembourg)" },
  { code: "+853", label: "+853 (Macau)" },
  { code: "+261", label: "+261 (Madagascar)" },
  { code: "+265", label: "+265 (Malawi)" },
  { code: "+60", label: "+60 (Malaysia)" },
  { code: "+960", label: "+960 (Maldives)" },
  { code: "+223", label: "+223 (Mali)" },
  { code: "+356", label: "+356 (Malta)" },
  { code: "+692", label: "+692 (Marshall Islands)" },
  { code: "+596", label: "+596 (Martinique)" },
  { code: "+222", label: "+222 (Mauritania)" },
  { code: "+230", label: "+230 (Mauritius)" },
  { code: "+52", label: "+52 (Mexico)" },
  { code: "+373", label: "+373 (Moldova)" },
  { code: "+377", label: "+377 (Monaco)" },
  { code: "+976", label: "+976 (Mongolia)" },
  { code: "+382", label: "+382 (Montenegro)" },
  { code: "+212", label: "+212 (Morocco)" },
  { code: "+258", label: "+258 (Mozambique)" },
  { code: "+95", label: "+95 (Myanmar)" },
  { code: "+264", label: "+264 (Namibia)" },
  { code: "+674", label: "+674 (Nauru)" },
  { code: "+977", label: "+977 (Nepal)" },
  { code: "+31", label: "+31 (Netherlands)" },
  { code: "+64", label: "+64 (New Zealand)" },
  { code: "+505", label: "+505 (Nicaragua)" },
  { code: "+227", label: "+227 (Niger)" },
  { code: "+234", label: "+234 (Nigeria)" },
  { code: "+389", label: "+389 (North Macedonia)" },
  { code: "+47", label: "+47 (Norway)" },
  { code: "+968", label: "+968 (Oman)" },
  { code: "+92", label: "+92 (Pakistan)" },
  { code: "+680", label: "+680 (Palau)" },
  { code: "+507", label: "+507 (Panama)" },
  { code: "+675", label: "+675 (Papua New Guinea)" },
  { code: "+595", label: "+595 (Paraguay)" },
  { code: "+51", label: "+51 (Peru)" },
  { code: "+63", label: "+63 (Philippines)" },
  { code: "+48", label: "+48 (Poland)" },
  { code: "+351", label: "+351 (Portugal)" },
  { code: "+1-787", label: "+1-787 (Puerto Rico)" },
  { code: "+974", label: "+974 (Qatar)" },
  { code: "+40", label: "+40 (Romania)" },
  { code: "+7", label: "+7 (Russia)" },
  { code: "+250", label: "+250 (Rwanda)" },
  { code: "+1-869", label: "+1-869 (Saint Kitts and Nevis)" },
  { code: "+1-758", label: "+1-758 (Saint Lucia)" },
  { code: "+1-784", label: "+1-784 (Saint Vincent and the Grenadines)" },
  { code: "+685", label: "+685 (Samoa)" },
  { code: "+378", label: "+378 (San Marino)" },
  { code: "+239", label: "+239 (Sao Tome and Principe)" },
  { code: "+966", label: "+966 (Saudi Arabia)" },
  { code: "+221", label: "+221 (Senegal)" },
  { code: "+381", label: "+381 (Serbia)" },
  { code: "+248", label: "+248 (Seychelles)" },
  { code: "+232", label: "+232 (Sierra Leone)" },
  { code: "+65", label: "+65 (Singapore)" },
  { code: "+1-721", label: "+1-721 (Sint Maarten)" },
  { code: "+421", label: "+421 (Slovakia)" },
  { code: "+386", label: "+386 (Slovenia)" },
  { code: "+677", label: "+677 (Solomon Islands)" },
  { code: "+252", label: "+252 (Somalia)" },
  { code: "+27", label: "+27 (South Africa)" },
  { code: "+82", label: "+82 (South Korea)" },
  { code: "+211", label: "+211 (South Sudan)" },
  { code: "+34", label: "+34 (Spain)" },
  { code: "+94", label: "+94 (Sri Lanka)" },
  { code: "+249", label: "+249 (Sudan)" },
  { code: "+597", label: "+597 (Suriname)" },
  { code: "+46", label: "+46 (Sweden)" },
  { code: "+41", label: "+41 (Switzerland)" },
  { code: "+963", label: "+963 (Syria)" },
  { code: "+886", label: "+886 (Taiwan)" },
  { code: "+992", label: "+992 (Tajikistan)" },
  { code: "+255", label: "+255 (Tanzania)" },
  { code: "+66", label: "+66 (Thailand)" },
  { code: "+1-242", label: "+1-242 (The Bahamas)" },
  { code: "+220", label: "+220 (The Gambia)" },
  { code: "+228", label: "+228 (Togo)" },
  { code: "+676", label: "+676 (Tonga)" },
  { code: "+1-868", label: "+1-868 (Trinidad and Tobago)" },
  { code: "+216", label: "+216 (Tunisia)" },
  { code: "+90", label: "+90 (Turkey)" },
  { code: "+993", label: "+993 (Turkmenistan)" },
  { code: "+1-649", label: "+1-649 (Turks and Caicos Islands)" },
  { code: "+688", label: "+688 (Tuvalu)" },
  { code: "+971", label: "+971 (UAE)" },
  { code: "+256", label: "+256 (Uganda)" },
  { code: "+380", label: "+380 (Ukraine)" },
  { code: "+44", label: "+44 (United Kingdom)" },
  { code: "+1", label: "+1 (United States)" },
  { code: "+598", label: "+598 (Uruguay)" },
  { code: "+1-340", label: "+1-340 (US Virgin Islands)" },
  { code: "+998", label: "+998 (Uzbekistan)" },
  { code: "+678", label: "+678 (Vanuatu)" },
  { code: "+58", label: "+58 (Venezuela)" },
  { code: "+84", label: "+84 (Vietnam)" },
  { code: "+967", label: "+967 (Yemen)" },
  { code: "+260", label: "+260 (Zambia)" },
  { code: "+263", label: "+263 (Zimbabwe)" },
];

const DriverDetailsCard = ({
  driverInfo = {},
  isExpanded,
  onToggle,
  onDriverInfoChange,
  onPhotoSelect,
  photoUrl,
  rideId,
  recordId,
  locked = false,
  onSubmitSuccess = () => {},
}) => {
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(
    driverInfo.driver_contact_number ||
      driverInfo["Driver Contact Number"] ||
      ""
  );
  const [driverName, setDriverName] = useState(
    driverInfo.driver_name || driverInfo["Driver Name"] || ""
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFileObject, setSelectedFileObject] = useState(null);
  const fileInputRef = React.useRef(null);

  const handlePhotoCapture = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelect = async (e) => {
    let file;

    // Handle both event object (from file input) and File object (from PhotoCaptureButton)
    if (e instanceof File) {
      file = e;
    } else if (e?.target?.files?.[0]) {
      file = e.target.files[0];
    }

    if (file) {
      setSelectedFileObject(file);
      onPhotoSelect(file);
    }
  };

  const handleSaveMobileNumber = () => {
    if (!countryCode || !phoneNumber) {
      alert("Please select country code and enter phone number");
      return;
    }
    const fullPhoneNumber = `${countryCode}${phoneNumber}`;
    onDriverInfoChange({
      driver_contact_number: fullPhoneNumber,
    });
  };

  const handleSubmitDriverInfo = async () => {
    if (!driverName || !phoneNumber || !countryCode) {
      toast.error("Please fill in all required fields");
      return;
    }

    try {
      setIsSubmitting(true);

      let selfieUrl = null;

      // Upload selfie if file was selected
      if (selectedFileObject) {
        if (
          !["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(
            selectedFileObject.type
          )
        ) {
          toast.error("Please select a JPG, JPEG, PNG, or WebP image.");
          return;
        }
        selfieUrl = await uploadAPI.uploadPhoto(
          selectedFileObject,
          rideId,
          "driver_selfie.jpg"
        );
      } else if (photoUrl && photoUrl.startsWith("http")) {
        // If photoUrl is already an HTTP URL, use it directly
        selfieUrl = photoUrl;
      }

      const fullPhoneNumber = `${countryCode}${phoneNumber}`;
      const payload = {
        driver_name: driverName,
        driver_contact_number: fullPhoneNumber,
        ...(selfieUrl && { driver_selfie_url: selfieUrl }),
      };

      const response = await rideAPI.submitDriverInfo(
        rideId,
        recordId,
        payload
      );

      if (response.success) {
        toast.success("Driver info submitted successfully!");
        onSubmitSuccess(response);
      }
    } catch (err) {
      console.error("Failed to submit driver info:", err);
      if (err.message && err.message.includes("409")) {
        toast.error("Driver info already submitted (write-once)");
      } else {
        toast.error(err.message || "Failed to submit driver info");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden transition-all duration-300">
      {/* Collapsed Summary */}
      <button
        onClick={onToggle}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <div className="text-left">
          <p className="font-medium text-gray-900">Driver Details</p>
        </div>
        <ChevronDown
          className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Expanded Content */}
      {isExpanded && (
        <div className="border-t border-gray-200 px-4 py-4 space-y-4 bg-gray-50">
          {/* Driver Name */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase block mb-2">
              Driver Name
            </label>
            <input
              type="text"
              value={driverName}
              onChange={(e) => {
                setDriverName(e.target.value);
                onDriverInfoChange({ driver_name: e.target.value });
              }}
              placeholder="Enter your name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              disabled={locked}
            />
          </div>

          {/* Driver Contact with Country Code */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase block mb-2">
              Driver Contact Number
            </label>
            <div className="space-y-2">
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value="">Select country code</option>
                {COUNTRY_CODES.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.label}
                  </option>
                ))}
              </select>

              <div className="flex gap-2">
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Phone number"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                  disabled={locked}
                />
                <button
                  onClick={handleSaveMobileNumber}
                  className="px-3 py-2 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors"
                >
                  Save
                </button>
              </div>
            </div>
          </div>

          {/* Driver Selfie */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase block mb-2">
              Driver Selfie
            </label>
            <div className="flex items-center gap-3">
              {photoUrl ? (
                <div className="relative w-20 h-20 rounded-lg overflow-hidden border-2 border-green-400">
                  <img
                    src={photoUrl}
                    alt="Driver selfie"
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <div className="w-20 h-20 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-100">
                  <Camera className="w-8 h-8 text-gray-400" />
                </div>
              )}
              <PhotoCaptureButton
                onPhotoSelect={handleFileSelect}
                disabled={locked}
                hasPhoto={!!photoUrl}
                buttonText="Capture Photo"
                retakeText="Retake Photo"
              />
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleFileSelect}
                className="hidden"
                disabled={locked}
              />
            </div>
          </div>

          {/* Submit Button */}
          {!locked && (
            <button
              onClick={handleSubmitDriverInfo}
              disabled={isSubmitting || !driverName || !phoneNumber}
              className="w-full px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isSubmitting ? (
                <SubmitCountdown />
              ) : (
                <>
                  <Upload className="w-4 h-4" />
                  Submit Driver Info
                </>
              )}
            </button>
          )}
          {locked && (
            <div className="px-4 py-2 bg-green-50 border border-green-200 rounded-lg text-center">
              <p className="text-xs font-medium text-green-700">
                ✓ Driver info submitted
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DriverDetailsCard;
